import { z, ZodType } from 'zod';
import { getDefaults, Validation } from '@mews/framework';
import {
    PosMicrosIntegrationAccountingCategory,
    PosMicrosIntegrationAccountingCategoryListItem,
    PosMicrosIntegrationServiceTime,
} from '@mews-commander/data-access';
import { FieldNames } from '../fieldNames';
import { AccountingCategoriesCount } from '../microsOutlets/accountingCategoriesCount';

const accountingCategoryListItemSchema = z.object({
    [FieldNames.categoryId]: z.coerce.string().default('').optional(),
    [FieldNames.taxCodes]: z.string().array().default([]).optional(),
}) satisfies ZodType<PosMicrosIntegrationAccountingCategoryListItem>;

const tipsAccountingCategorySchema = z.object({
    [FieldNames.id]: z.coerce.string().default('').optional(),
    [FieldNames.taxCodes]: z.string().array().default([]).optional(),
}) satisfies ZodType<PosMicrosIntegrationAccountingCategory>;

const createDefaultArray = (accountingCategoriesCount: AccountingCategoriesCount) => {
    return new Array(accountingCategoriesCount).fill(getDefaults(accountingCategoryListItemSchema));
};

export const serviceTimeFormSchema = z.object({
    [FieldNames.timeId]: Validation.String.Required,
    [FieldNames.name]: z.coerce.string().default(''),
    [FieldNames.time]: z.number().default(0),
    [FieldNames.isDefault]: z.boolean().default(false),
    [FieldNames.netSalesAccountingCategories]: accountingCategoryListItemSchema
        .array()
        .default(createDefaultArray(AccountingCategoriesCount.XmlPosNetSales)),
    [FieldNames.discountAccountingCategories]: accountingCategoryListItemSchema
        .array()
        .default(createDefaultArray(AccountingCategoriesCount.XmlPosDiscount)),
    [FieldNames.serviceChargeAccountingCategories]: accountingCategoryListItemSchema
        .array()
        .default(createDefaultArray(AccountingCategoriesCount.XmlPosServiceCharge)),
    [FieldNames.tipsAccountingCategory]: tipsAccountingCategorySchema.optional(),
}) satisfies ZodType<PosMicrosIntegrationServiceTime>;
